import Page from "@jumbo/shared/Page";
import AuthenticateAndRolesMiddleware from "../Middleware";
import AddEditMET from "app/pages/Profile/AddEditMET";
import AddNomineeForm from "app/pages/Profile/Nominee/AddNomineeForm";
import ListingNominee from "app/pages/Profile/Nominee/ListingNominee/ListingNominee";


const routesName = "/dashboards/myProfile";

export const profileRoute = [
  {
    middleware: [
      {
        element: AuthenticateAndRolesMiddleware,
        fallbackPath: "/login",
      },
    ],
    routes: [
      {
        path: `${routesName}/edit`,
        element: <Page component={AddEditMET} />,
      },
      {
        path: `${routesName}/nominee`,
        element: <Page component={ListingNominee} />,
      },
      {
        path: `${routesName}/nominee/add`,
        element: <Page component={AddNomineeForm} />,
      },
      {
        path: `${routesName}/nominee/edit/:nomineeId`,
        element: <Page component={AddNomineeForm} />,
      },
    ],
  },]
